import { Box, Paper } from '@mui/material';
import { ReactNode } from 'react';

import { useSxStyles } from './useStyles';

type PropsType = {
  icon: ReactNode;
  title: string;
  children?: ReactNode;
};
export const EmployeeProposalsHeader = (props: PropsType) => {
  const { children, icon, title } = props;
  const sxStyles = useSxStyles();

  return (
    <Paper sx={sxStyles.root}>
      <Box sx={sxStyles.status}>
        {icon}
        {title}
      </Box>
      {!!children && <Box sx={sxStyles.children}>{children}</Box>}
    </Paper>
  );
};
